export const useUploadProgressStore = defineStore('uploadProgress', () => {
  // state
  const progress = ref<string | null>(null)

  // getters
  const percentage = computed(() => progress.value)

  // mutations
  function updateProgress(newProgress: string | null) {
    progress.value = newProgress
  }

  const reset = () => updateProgress(null)

  return { progress, percentage, updateProgress, reset }
})
